module.exports = __webpack_public_path__ + "media/images/thumbs/physanims/a4-8-2ffdb63ac13e397dce2c1480c49574c0.jpg";